/* emv/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const KEYSSchema = t.type({
    Name: t.string,
    Value: t.string
})

const CONFIGSSchema = t.type({
  CardType: t.string,
  ProductID: t.string,
  ProductName: t.string,
  GoogleVasCollectorID: t.number,
  CardPrefix: t.string,
  CountryCode: t.string,
  Keys: tOptional(t.array(KEYSSchema)),
  
});

const AttributeCodec = t.intersection([
  t.type({
    // Name: tOptional(t.string),
    // For: tOptional(t.string),
    // AID: tOptional(t.array(AIDSchema)),
    Configs: tOptional(t.array(CONFIGSSchema)),
    ConfigName: t.string,
  }),
  t.partial({}),
]);

const DataCodec = t.type({
  id: tId,
  type: t.string,
  attributes: AttributeCodec,
});
export type Data = t.TypeOf<typeof DataCodec>;

export const CloseLoopCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "CloseLoopCodec"
);

export type CloseLoop = t.TypeOf<typeof CloseLoopCodec>;

export enum CloseLoopActionTypes {
  FETCH = "@@closeloop/FETCH",
  FETCH_SUCCESS = "@@closeloop/FETCH_SUCCESS",
  FETCH_ERROR = "@@closeloop/FETCH_ERROR",
}

export interface CloseLoopState {
  readonly loading: boolean;
  readonly data: Data[];
  readonly errors?: string;
}
